 <template>
  <footer class="site-footer">
    <div class="footer-overlay"></div>

    <div class="footer-container">
      <div class="footer-column">
        <h3>Sitemap</h3>
        <ul>
          <li><router-link :to="{ path: '/', hash: '#home' }">Home </router-link></li>
          <li><router-link :to="{ path: '/', hash: '#features' }">Features</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#pricing' }">Pricing</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#partners' }">Channel Partners</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#contact' }">Contact</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>Contact Us</h3>
        <div class="contact-info">
          <div class="contact-item">
            <i class="fa-solid fa-location-dot"></i>
            <span>Third Floor, Royal Oak Building, TK Junction, Thana, Kannur, Kerala, Pin:670002</span>
          </div>
          <div class="contact-item">
            <i class="fa-solid fa-phone"></i>
            <a href="tel:9633011603">9633011603</a>
          </div>
          <div class="contact-item">
            <i class="fa-solid fa-envelope"></i>
            <a href="mailto:sales@smartwaveindia.com">sales@smartwaveindia.com</a>
          </div>
          <div class="contact-item">
            <i class="fa-solid fa-globe"></i>
            <a href="http://www.smartwaveindia.com" target="_blank">www.smartwaveindia.com</a>
          </div>
        </div>
      </div>

      <div class="footer-column map-container">
        <h3>Find Us</h3>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3936.537114995185!2d75.37060617461458!3d11.87447753991039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba43f2f8d0902ed%3A0x9f9d01f0f1d9f37!2sSmartwave%20India%20Private%20Limited!5e0!3m2!1sen!2sin!4v1693757200000!5m2!1sen!2sin"
          width="100%"
          height="200"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>

    <div class="footer-bottomline">
      <div class="contact-buttons">
        <a href="tel:9633011595" class="btn sales"><i class="fas fa-phone"></i> Sales: 9633011595</a>
        <a href="tel:9846400481" class="btn franchise"><i class="fas fa-comment-dots"></i> Franchise Enquiry: 9846400481</a>
        <a href="tel:9633018603" class="btn support"><i class="fas fa-mobile"></i> Support: 9633018603</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
.site-footer {
  position: relative; /* ✅ Needed for overlay positioning */
  background: #fff;
  color: #206A98;
  padding: 50px 20px;
  border-top: 1px solid #e0e0e0;
  overflow: hidden; /* ✅ Ensures overlay stays contained */
}

/* 🌟 Overlay styles */
.footer-overlay {
  display: none; /* hidden by default */
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  position: relative;
  z-index: 2; /* ✅ ensures content stays above overlay */
}

.footer-column {
  flex: 1;
  min-width: 260px;
}

.footer-column h3 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  color: #009886;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column ul li {
  margin-bottom: 12px;
  text-align: center;
  padding-left: 10px;
}

.footer-column a {
  color: #206A98;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  text-decoration: underline;
  color: #206A98;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.4;
}

.contact-item i {
  font-size: 16px;
  color: #009886;
  margin-top: 3px;
}

.map-container iframe {
  border-radius: 8px;
  margin-top: 10px;
  width: 100%;
  height: 200px;
}

.footer-bottomline {
  padding: 40px 20px;
  font-family: Arial, sans-serif;
  position: relative;
  z-index: 2;
}

.footer-bottomline .btn {
  padding: 12px 18px;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: 0.3s;
}

.sales {
  background: #206A98;
}

.franchise {
  background: #dc3545;
}

.support {
  background: #009886;
}

.footer-bottomline .btn:hover {
  opacity: 0.85;
}

.contact-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 25px;
  gap: 15px;
}

/* 📱 Tablet view (≤768px) */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
  }

  .footer-column {
    text-align: center;
  }

  .contact-item {
    flex-direction: column;
    align-items: center;
  }
}

/* 📱 Mobile view (≤480px) */
@media (max-width: 480px) {
  .site-footer {
    padding: 30px 10px;
  }

  .footer-overlay {
    display: block; /* ✅ show overlay only on mobile */
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45); /* ✅ semi-transparent dark overlay */
    z-index: 1;
    backdrop-filter: blur(4px); /* ✅ optional blur for nice effect */
  }

  .footer-column h3 {
    font-size: 16px;
  }

  .footer-column ul li {
    font-size: 14px;
  }

  .contact-item i {
    font-size: 14px;
  }

  .footer-bottomline {
    padding: 20px 10px;
  }

  .footer-bottomline .btn {
    padding: 10px 14px;
    font-size: 14px;
  }

  .map-container iframe {
    height: 150px;
  }
}
</style>
